import {
  ServiceTypes,
  useGetServiceListNameIdQuery,
  type PostFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { sortBy, uniq } from "lodash";
import { useMemo, useState } from "react";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = PostFilter | null | undefined;

export function ItemGridFilterTileType() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();
  const { data, loading, error } = useGetServiceListNameIdQuery({
    variables: {
      page: 0,
      perPage: 1000,
      sortField: "name",
      sortOrder: "ASC",
      filter: {
        type: ServiceTypes.Tile,
        q: query ? query : undefined,
      },
    },
  });

  const filterWithTileType: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      data?.items
        ?.slice()
        ?.filter((item) => !!item?.id)
        ?.map((item) => {
          const id = item.id ?? "";
          const name = item.name ?? "";
          const checked = filterWithTileType?.tileType?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        }) ?? [];

    return sortBy(values, (entry) => entry.name);
  }, [data?.items, filterWithTileType?.tileType]);

  return (
    <ItemGridFilterDataList
      error={error}
      items={items}
      loading={loading}
      property="tileType"
      text="Content Type"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.tileType;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.tileType = uniq([...(draft.tileType ?? []), id]);
            } else if (draft.tileType?.length) {
              draft.tileType = draft.tileType.filter(
                (tileType) => tileType !== id,
              );
            }

            if (!draft.tileType?.length) {
              delete draft.tileType;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        if (checked) {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              draft.tileType = items.map((item) => item.id);
            }
          });
        } else {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              delete draft.tileType;
            }
          });
        }
      }}
    />
  );
}
